import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import React from "react";

// Inicialización de Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      // Opciones adicionales de configuración para Session Replay
      maskAllText: true, // Enmascara todo el texto visible (datos de juicios/montos no viajan en claro)
      blockAllMedia: true, // Bloquea todo el contenido multimedia visible
      // Corta la grabación si la pantalla muta demasiado, en vez de mandar un segmento gigante
      // (el servidor de Sentry rechaza los envíos grandes con 413). Solo afecta al replay.
      mutationLimit: 3000,
    }),
  ],
  tracesSampleRate: 1.0, // Muestra del 100% para las trazas de rendimiento
  replaysSessionSampleRate: 0, // Sin replays al azar: solo se graba cuando hay un error
  replaysOnErrorSampleRate: 1.0, // Captura Replay cuando ocurre un error
  debug: import.meta.env.VITE_SENTRY_DEBUG_MODE === 'true', // La env llega como string: "false" no debe activarlo
});

export default Sentry;
